{
  "paymentMethodUnavailable": "ไม่สามารถใช้วิธีชำระเงินนี้ได้",
  "serverError": "เกิดข้อผิดพลาดของเซิร์ฟเวอร์ โปรดลองอีกครั้งภายหลัง",
  "tradeRecommendation": "รายการที่แนะนำ",
  "tradeRecommendationDescription": "ไม่พบคำสั่งซื้อที่ตรงกับจำนวนเงินของคุณ แต่มีจำนวนที่แนะนำให้เลือก ต้องการทำรายการตามจำนวนที่แนะนำหรือไม่",
  "tradeWithRecommendation": "ตกลง ทำรายการตามจำนวนที่แนะนำ",
  "listOriginalAmount": "ไม่ ใช้จำนวนเดิมในการลงรายการ",
  "selectPaymentMethod": "โปรดเลือกวิธีชำระเงิน",
  "selectReceivingMethod": "โปรดเลือกวิธีรับเงิน",
  "fastTradingUnavailable": "ธุรกรรมด่วนใช้งานไม่ได้ชั่วคราว โปรดลองอีกครั้งภายหลัง",
  "paymentAmountLimitExceeded": "เกินวงเงินชำระสูงสุด",
  "securityReminder": "โปรดระวัง {{token}} ติดต่อผู้ใช้ผ่านฝ่ายบริการลูกค้าออนไลน์เท่านั้น และจะไม่ติดต่อผ่านโทรศัพท์ Alipay หรือ WeChat",
  "buyToken": "ซื้อ{{token}}",
  "sellToken": "ขาย{{token}}",
  "selectTradingMethod": "เลือกวิธีทำรายการ",
  "paymentMethodsUnavailable": "วิธีชำระเงินใช้งานไม่ได้ชั่วคราว",
  "unavailableMethodRetry": "{{methods}} ไม่สามารถประมวลผลการชำระเงินนี้ได้เมื่อครู่ วิธีที่มีจุดสีแดงยังลองใหม่ได้ หรือเลือกวิธีอื่น",
  "unavailableMethodChooseOther": "{{methods}} ไม่สามารถประมวลผลการชำระเงินนี้ได้เมื่อครู่ โปรดเลือกวิธีอื่น",
  "vipFastPayEligibility": "คุณอยู่ระดับ VIP {{level}} วิธี{{methodType}}ต่อไปนี้ตรงตามเงื่อนไขธุรกรรมด่วน",
  "continueStandardC2C": "ดำเนินการ C2C ปกติต่อ",
  "methodUnavailableRetry": "{{method}} ใช้งานไม่ได้ชั่วคราว ลองใหม่ได้",
  "unavailableRetry": "ใช้งานไม่ได้ชั่วคราว ลองใหม่ได้",
  "selectThisMethod": "เลือกวิธีนี้",
  "vipAvailability": "ช่วง VIP ที่ใช้ได้",
  "fee": "ค่าธรรมเนียม",
  "expectedCredit": "คาดว่าจะได้รับ",
  "fastPayCollectionInformation": "ข้อมูลรับเงินธุรกรรมด่วน",
  "scanToPay": "ใช้ {{method}} สแกนคิวอาร์โค้ดเพื่อชำระเงิน",
  "payUsingInformation": "โปรดชำระเงินตามข้อมูลด้านล่าง",
  "receivingQrCode": "คิวอาร์โค้ดรับเงิน {{method}}",
  "orderNumber": "หมายเลขคำสั่งซื้อ",
  "receivingName": "ชื่อผู้รับเงิน",
  "receivingAccount": "บัญชีผู้รับเงิน",
  "amountDue": "ยอดที่ต้องชำระ",
  "transactionChannel": "ช่องทางทำรายการ",
  "paymentDeadline": "กำหนดเวลาชำระเงิน",
  "notice": "หมายเหตุ",
  "payExactAmount": "โปรดชำระเงินตามยอดที่ต้องชำระอย่างเคร่งครัด",
  "close": "ปิด",
  "kycRequired": "โปรดยืนยันตัวตนก่อน",
  "kycRequiredDescription": "โปรดยืนยันตัวตนก่อนจึงจะใช้วิธีทำรายการนี้ได้",
  "gotIt": "รับทราบ",
  "goToKyc": "ไปยืนยันตัวตน",
  "cannotStartTrade": "ไม่สามารถเริ่มรายการใหม่ได้",
  "buyOrderInProgress": "มีคำสั่งซื้อที่กำลังดำเนินการอยู่ ต้องรอให้เสร็จก่อนจึงจะเริ่มรายการใหม่ได้",
  "minimumTransactionRequired": "โปรดระบุจำนวนขั้นต่ำต่อรายการ",
  "minimumLessThanListed": "ต้องน้อยกว่าจำนวนที่ลงรายการทั้งหมด",
  "insufficientBalance": "ยอดคงเหลือไม่เพียงพอสำหรับการลงรายการ",
  "listedQuantityLimitExceeded": "เกินขีดจำกัดจำนวนที่ลงรายการ",
  "availableBalance": "ยอดคงเหลือที่ใช้ได้:",
  "selectedReceivingMethods": "เลือกวิธีรับเงิน {{count}} วิธีแล้ว",
  "fastSell": "ขายด่วน",
  "fastSellSubmitted": "ส่งคำขอขายแล้ว ผลการรับเงินให้ยึดตามสถานะระบบ",
  "fastSellFailed": "ส่งคำขอขายไม่สำเร็จ โปรดลองอีกครั้งหรือใช้ C2C ปกติ",
  "providerOrderNumber": "หมายเลขคำสั่งซื้อผู้ให้บริการ",
  "providerFee": "ค่าธรรมเนียมผู้ให้บริการ",
  "status": "สถานะ",
  "remark": "หมายเหตุ",
  "minimumTransactionHint": "ผู้ซื้อต้องซื้ออย่างน้อยตามจำนวนนี้",
  "fastPayDetails": "รายละเอียดธุรกรรมด่วน",
  "orderStatus": "สถานะคำสั่งซื้อ",
  "closedAt": "เวลาปิด",
  "amountInformation": "ข้อมูลจำนวนเงิน",
  "creditedQuantity": "จำนวนที่เข้าบัญชี"
}
